import { gql } from '@apollo/client';

const OBJECTIVE_CRITERIA_TYPES_QUERY = gql`
    query {
        objectiveCriterionTypes {
            edges {
                node {
                    id
                    key
                    name
                    description
                    kafkaTopic
                    targetCountRequired
                    targetValueRequired
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;

export default OBJECTIVE_CRITERIA_TYPES_QUERY;
